<script setup lang="ts">
  import { CircleAlert } from 'lucide-vue-next';
  import { ref } from 'vue';
  import CheckboxCheckIcon from '@/shared/assets/icons/CheckboxCheckIcon.svg';
  import { Accordion, AccordionContent, AccordionItem } from '@/shared/ui';
  import PermissionsAccordionTrigger from './PermissionsAccordionTrigger.vue';

  export interface PermissionsFieldGroup {
    name: string;
    fields: string[];
  }

  withDefaults(defineProps<{ groups?: PermissionsFieldGroup[] }>(), {
    groups: () => [],
  });

  const openSections = ref(['fields-with-permissions']);
</script>

<template>
  <Accordion v-model="openSections" type="multiple">
    <AccordionItem
      value="fields-with-permissions"
      class="rounded-lg border border-gray-02 p-4 last:border-b"
      data-testid="permissions-fields-with-permissions-section"
    >
      <PermissionsAccordionTrigger :icon="CheckboxCheckIcon">
        Campos com permissões
      </PermissionsAccordionTrigger>

      <AccordionContent class="pt-4 pb-0">
        <div
          v-if="groups.length === 0"
          class="flex flex-col items-center gap-2 text-sm text-gray-07"
          data-testid="permissions-fields-with-permissions-empty"
        >
          <CircleAlert class="size-5 text-[var(--theme-secondary-ink)]" aria-hidden="true" />
          <p>Sem permissões aplicadas</p>
        </div>

        <div v-else class="flex flex-col">
          <section
            v-for="(group, groupIndex) in groups"
            :key="`${groupIndex}-${group.name}`"
            class="flex flex-col gap-2 border-b border-gray-02 px-2 py-4 first:pt-0 last:border-b-0"
            data-testid="permissions-fields-group"
          >
            <h4 class="text-sm font-semibold text-gray-07">{{ group.name }}</h4>
            <ol class="flex flex-col gap-2 text-sm text-gray-07">
              <li v-for="(field, index) in group.fields" :key="`${group.name}-${index}`">
                {{ index + 1 }}º. {{ field }}
              </li>
            </ol>
          </section>
        </div>
      </AccordionContent>
    </AccordionItem>
  </Accordion>
</template>
